module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"documents":"Documents","references":"References","referencesPlaceholder":"Enter reference texts here","uploadDocuments":"Upload Documents"},"no":{"documents":"Dokumenter","references":"Referanser","referencesPlaceholder":"Skriv inn referansetekster her","uploadDocuments":"Last opp dokumenter"}}')
  delete Component.options._Ctor
}
